import { createSelector } from 'reselect';
import { arrayToMap } from '../../utils/collections';

function deviceIdFn(d) {
  return d.stagingId;
}
function topicFn(p) {
  return p.topic;
}
function equipIdFn(e) {
  return e.equipId;
}

const getBuildingStaging = createSelector(
  [
    (state, buildingId) => state.entities.staging.devicesByBuilding[buildingId],
    (state, buildingId) => state.entities.staging.pointsByBuilding[buildingId],
    (state, buildingId) => state.entities.staging.equipmentByBuilding[buildingId],
    (state) => state.entities.devices.byId,
    (state) => state.entities.points.byId,
    (state) => state.entities.equipment.byId,
    (state) => state.entities.deployments.deployments,
    (state) => state.entities.pointTypes.byId,
    (state) => state.entities.units.byId,
    (state) => state.entities.equipTypes.byId,
    (state, buildingId) => state.entities.staging.validation?.points[buildingId],
    (state, buildingId) => state.entities.staging.validation?.equipment[buildingId],
  ],
  (
    stagingDevicesList,
    stagingPointsList,
    stagingEquipmentList,
    publishedDevicesById,
    publishedPointsById,
    publishedEquipmentById,
    deployments,
    pointTypes,
    units,
    equipTypes,
    pointValidationByTopic,
    equipmentValidationByEquipId
  ) => {
    const stagingDevices = arrayToMap(
      stagingDevicesList?.filter(Boolean).map((d) => ({
        ...d,
        points: [],
        deviceEquipment: null,
        deployment: deployments?.[d.deploymentId],
        published: publishedDevicesById[d.publishedDeviceId],
      })) ?? [],
      deviceIdFn
    );
    const stagingEquipment = arrayToMap(
      (stagingEquipmentList ?? []).filter(Boolean).map((equip) => {
        const e = {
          ...equip,
          points: [],
          devices: [],
          equipmentDevice: stagingDevices.get(equip.equipmentDeviceId),
          equipmentType: equipTypes?.[equip.equipmentTypeId],
          validation: equipmentValidationByEquipId?.[equip.equipId],
          published: publishedEquipmentById[equip.publishedEquipmentId],
        };
        if (e.equipmentDevice) e.equipmentDevice.deviceEquipment = e;
        return e;
      }),
      equipIdFn
    );
    const stagingPoints = arrayToMap(
      Object.values(stagingPointsList ?? {})
        .filter(Boolean)
        .map((point) => {
          const device = stagingDevices.get(point.stagingDeviceId);
          const newPoint = {
            ...point,
            equip: point.equipIds.map((equipId) => stagingEquipment.get(equipId)).filter(Boolean),
            pointType: pointTypes?.[point.pointTypeId],
            unit: units?.[point.rawUnitId],
            device,
            published: publishedPointsById[point.publishedPointId],
            validation: pointValidationByTopic?.[point.topic],
          };
          // It's possible for points to be loaded before devices, so need to be prepared for that edge
          device.points?.push(newPoint);
          newPoint.equip.forEach((equip) => {
            equip.points.push(newPoint);
            if (
              device !== undefined &&
              !equip.devices.some((d) => d.stagingId === device.stagingId)
            ) {
              equip.devices.push(device);
            }
          });
          return newPoint;
        }),
      topicFn
    );

    return {
      stagingDevices,
      stagingPoints,
      stagingEquipment,
    };
  }
);

export default getBuildingStaging;
